import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { SuperAdminService } from '../../../super-admin.service';
import { ToastrService } from 'ngx-toastr';
import { sum } from 'lodash';

@Component({
  selector: 'app-gst-invoice',
  templateUrl: './gst-invoice.component.html',
  styleUrls: ['./gst-invoice.component.css']
})
export class GstInvoiceComponent implements OnInit {
  invtot:any;
  users: any;
  fivePercent:any; // Keeping name for backward compatibility or renaming to ninePercent? Better to rename to ninePercent.
  ninePercent:any;
  eightPercent :any;
  totalInvValueWithGST:any;
  paramId;
  constructor(private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService) {
    this.activatedRoute.params.subscribe(param => {
      this.paramId = param.id;
      this.getParticularInvoice(this.paramId);
    })
  }

  ngOnInit(): void {
  }
  // getParticularInvoice(id: string) {
  //   this.superAdminService.getParticularInvoice(id)
  //     .subscribe((res: { status: any, message: any, data: any }) => {

  //       if (res.status == true) {
  //         var rawdata = res.data;
  //         this.users = rawdata[0].invoice;
  //         console.log("this.users", this.users);
  //         //this.users = this.users[0].invoice;
  //         this.invtot = 0;
  //         this.users.forEach( (value:any)=> {
  //           let balancepaidArray = value.vehicleRate || [];
  //           this.invtot += balancepaidArray.reduce((a: number, b: any) => a + Number(b || 0), 0);
  //         }); 
  //         this.ninePercent = (this.invtot*9)/100;
  //         this.eightPercent = (this.invtot*8)/100;
  //         // this.totalInvValueWithGST = this.invtot + 2*(this.ninePercent) + this.eightPercent;
  //         this.totalInvValueWithGST = this.invtot + 2*(this.ninePercent);
  //       }
  //       else {
  //         alert(res.message)
  //       }

  //     }, error => {
  //     });
  // }
  receiverDetails: any = {};

getParticularInvoice(id: string) {
  this.superAdminService.getParticularInvoice(id)
    .subscribe((res: { status: any, message: any, data: any }) => {

      if (res.status == true) {

        const rawdata = res.data;

        this.users = rawdata[0].invoice;

        console.log("this.users", this.users);

        // Receiver / Billed To details
        if (this.users && this.users.length > 0) {
          const invoiceData = this.users[0];

          this.receiverDetails = {
            name: invoiceData.consignee_name?.[0] || 'NA',
            address: invoiceData.consignee_address?.[0] || 'NA',
            gstin: invoiceData.GSTIN?.[0] || 'NA',
            stateCode: invoiceData.stateCode?.[0] || 'NA',
            pan: invoiceData.PAN?.[0] || 'NA'
          };

          console.log("Receiver Details:", this.receiverDetails);
        }

        this.invtot = 0;

        const sumAmount = (amount: any): number => {
          const values = Array.isArray(amount) ? amount : [amount];
          return values.reduce(
            (total: number, value: any) => total + (Number(value) || 0),
            0
          );
        };

        const invoiceType = String(
          rawdata[0]?.invoiceType || this.users[0]?.invoiceTypeName?.[0] || ''
        ).trim().toLowerCase();
        const isFixedInvoice = [
          'fixed',
          'fixed rate invoice',
          'monthly fixed invoice'
        ].includes(invoiceType);

        this.users.forEach((value: any) => {
          if (isFixedInvoice) {
            this.invtot += sumAmount(value.vehicleRate);
          } else {
            this.invtot +=
              sumAmount(value.labourLoad) +
              sumAmount(value.labourUnload) +
              sumAmount(value.detention) +
              sumAmount(value.otherPayment) +
              // sumAmount(value.vehicleRate) +
              sumAmount(value.Frieght ?? value.Freight);
          }
        });

        this.ninePercent = (this.invtot * 9) / 100;
        this.eightPercent = (this.invtot * 8) / 100;

        this.totalInvValueWithGST =
          this.invtot + 2 * this.ninePercent;
      }

      else {
        alert(res.message);
      }

    }, error => {
      console.error(error);
    });
}
  backTo() {
    window.history.back()
  }

}
